import { FC } from 'react';

import { Formik } from 'formik';
import { isStrictEqual } from 'remeda';
import { BaseFieldArray, FormBodyContainer } from 'wbs-components-lib';

import { Typography } from '@mui/material';

import { AvailableTickets } from '@shared/components';
import { getRewardTypeSelectItems, getRewardWithChanceItem } from '@shared/utils';

import { ReferralUserRewardUpdateFormProps } from './types';
import { referralUserRewardSettingsSchema } from './validationSchema';

export const ReferralUserRewardUpdateForm: FC<ReferralUserRewardUpdateFormProps> = ({
  initialValues,
  isSubmitting = false,
  submitButtonCaption = 'Update',
  onSubmit,
}) => (
  <Formik
    initialValues={initialValues}
    onSubmit={onSubmit}
    validationSchema={referralUserRewardSettingsSchema}
    enableReinitialize
  >
    {({ submitForm, values, handleChange, handleBlur, errors, setFieldValue, touched }) => {
      const { personalChance: personalChanceValue } = values;

      const onReferralsSettingsSubmit = async () => {
        await submitForm();
      };

      const isSubmitButtonDisabled = isStrictEqual(values, initialValues);

      return (
        <FormBodyContainer
          isSubmitting={!!isSubmitting}
          onSubmit={onReferralsSettingsSubmit}
          submitButtonCaption={submitButtonCaption}
          isSubmitButtonDisabled={isSubmitButtonDisabled}
        >
          <Typography fontSize="16px" fontWeight={600}>
            Rewards (REFERRAL_MONEY exists is required)
          </Typography>
          <AvailableTickets rewardsDataValue={personalChanceValue} />
          <BaseFieldArray
            fieldArrayName="personalChance"
            items={personalChanceValue}
            getBaseFieldValue={getRewardWithChanceItem}
            selectFields={{
              type: getRewardTypeSelectItems(),
            }}
            touched={touched}
            errors={errors}
            label="Reward"
            handleBlur={handleBlur}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
          />
        </FormBodyContainer>
      );
    }}
  </Formik>
);
